/* Sōhei Homepage V3 — shared interactions.
   Idempotent + editor-safe: re-runs on shopify:section:load, guards every
   element so nothing double-binds, and re-queries the DOM on scroll so
   sections added later still animate. Feature-guarded + reduced-motion aware. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rvObserver = null, numObserver = null;

  /* ── Scroll-reveal ── */
  function initReveals() {
    var els = document.querySelectorAll('.sohei-v3 .rv:not(.in):not([data-sv3rv])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    if (!rvObserver) {
      rvObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); rvObserver.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
    }
    els.forEach(function (e) { e.setAttribute('data-sv3rv', '1'); rvObserver.observe(e); });
  }

  /* ── Hero rotating word ── */
  function initRot() {
    document.querySelectorAll('.sohei-v3 .rot[data-words]:not([data-sv3rot])').forEach(function (rot) {
      rot.setAttribute('data-sv3rot', '1');
      if (reduce) return;
      var words = (rot.getAttribute('data-words') || '').split('|').map(function (w) { return w.trim(); }).filter(Boolean);
      var el = rot.querySelector('.em');
      if (!el || words.length < 2) return;
      /* Lock the headline to its tallest phrase so a phrase that wraps to an extra line
         cannot change the hero's height (and shove everything below it) on every swap.
         Measured with layout height; re-run only when the width changes, never on the
         vertical resizes Safari's address bar fires while scrolling. */
      var h = rot.closest('h1');
      if (h) {
        var lockH = function () {
          var cur = el.textContent, max = 0;
          h.style.minHeight = '';
          words.forEach(function (w) { el.textContent = w; max = Math.max(max, h.offsetHeight); });
          el.textContent = cur;
          if (max) h.style.minHeight = max + 'px';
        };
        lockH();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(lockH);
        var lockedW = window.innerWidth;
        window.addEventListener('resize', function () {
          if (window.innerWidth !== lockedW) { lockedW = window.innerWidth; lockH(); }
        });
      }
      var i = 0;
      setInterval(function () {
        el.classList.add('out');
        setTimeout(function () { i = (i + 1) % words.length; el.textContent = words[i]; el.classList.remove('out'); }, 350);
      }, 2800);
    });
  }

  /* ── Marquee duplication (brands + testimonials) ── */
  function initMarquee() {
    document.querySelectorAll('.sohei-v3 [data-marquee]:not([data-sv3mq])').forEach(function (track) {
      track.setAttribute('data-sv3mq', '1');
      track.innerHTML += track.innerHTML;
    });
  }

  /* ── Count-up numbers ── */
  function runCount(el) {
    var t = parseFloat(el.getAttribute('data-count')), s = el.getAttribute('data-suffix') || '', t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / 1400, 1), v = t * (1 - Math.pow(1 - p, 3));
      el.textContent = (t % 1 ? v.toFixed(1) : Math.round(v)) + s;
      if (p < 1) requestAnimationFrame(step); else el.textContent = (t % 1 ? t.toFixed(1) : t) + s;
    }
    requestAnimationFrame(step);
  }
  function initCount() {
    var nums = document.querySelectorAll('.sohei-v3 [data-count]:not([data-sv3n])');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (el) { el.setAttribute('data-sv3n', '1'); el.textContent = el.getAttribute('data-count') + (el.getAttribute('data-suffix') || ''); });
      return;
    }
    if (!numObserver) {
      numObserver = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { runCount(en.target); numObserver.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -15% 0px' });
    }
    nums.forEach(function (el) { el.setAttribute('data-sv3n', '1'); numObserver.observe(el); });
  }

  /* ── Waterfall nav clicks ── */
  function initWf() {
    document.querySelectorAll('.sohei-v3 .wf-grid .wf-nav button:not([data-sv3wf])').forEach(function (b) {
      b.setAttribute('data-sv3wf', '1');
      b.addEventListener('click', function () {
        var grid = b.closest('.wf-grid');
        var t = grid && grid.querySelector('#' + b.getAttribute('data-t'));
        if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  /* ── Work gallery lightbox ── */
  function initLightbox() {
    var lb = document.getElementById('sv3-lb');
    if (!lb) return;
    document.querySelectorAll('.sohei-v3 .gtile:not([data-sv3tile])').forEach(function (t) { t.setAttribute('data-sv3tile', '1'); });
    if (lb.getAttribute('data-sv3lb')) return;   // bind controls once
    lb.setAttribute('data-sv3lb', '1');
    var media = lb.querySelector('.lb-media'), blur = lb.querySelector('.lb-blur'), tEl = lb.querySelector('.lb-t'), cEl = lb.querySelector('.lb-c'), cur = 0;
    function tiles() { return [].slice.call(document.querySelectorAll('.sohei-v3 .gtile')); }
    function clearMedia() { if (media) media.innerHTML = ''; }
    function show(i) {
      var ts = tiles(); if (!ts.length) return;
      cur = (i + ts.length) % ts.length;
      var t = ts[cur], full = t.getAttribute('data-full'), vid = t.getAttribute('data-video'), grad = t.getAttribute('data-grad');
      clearMedia();
      if (vid) {
        var v = document.createElement('video');
        v.src = vid; v.controls = true; v.autoplay = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
        if (full) v.poster = full;
        media.appendChild(v);
        if (blur) blur.style.backgroundImage = full ? "url('" + full + "')" : 'none';
      } else if (full) {
        var im = document.createElement('img');
        im.src = full; im.alt = t.getAttribute('data-title') || '';
        media.appendChild(im);
        if (blur) blur.style.backgroundImage = "url('" + full + "')";
      } else {
        var d = document.createElement('div'); d.className = 'lb-grad';
        d.style.background = grad || '#333';
        media.appendChild(d);
        if (blur) blur.style.backgroundImage = 'none';
      }
      if (tEl) tEl.textContent = t.getAttribute('data-title') || '';
      if (cEl) cEl.textContent = t.getAttribute('data-cat') || '';
      lb.classList.add('open'); document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    }
    function close() { lb.classList.remove('open'); document.documentElement.style.overflow = ''; document.body.style.overflow = ''; clearMedia(); }
    document.addEventListener('click', function (e) {
      var tile = e.target.closest && e.target.closest('.sohei-v3 .gtile');
      if (tile) { show(tiles().indexOf(tile)); }
    });
    var cl = lb.querySelector('.lb-close'); if (cl) cl.addEventListener('click', close);
    var pv = lb.querySelector('.lb-prev'); if (pv) pv.addEventListener('click', function () { show(cur - 1); });
    var nx = lb.querySelector('.lb-next'); if (nx) nx.addEventListener('click', function () { show(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
  }

  /* ── Live scroll updaters (re-query so late-added sections work) ── */
  function updDots() {
    var conns = document.querySelectorAll('.sohei-v3 .connector');
    if (!conns.length) return;
    var vh = window.innerHeight || 800, start = vh * 0.9, end = vh * 0.32;
    conns.forEach(function (c) {
      var dot = c.querySelector('.dot'), line = c.querySelector('.line');
      if (!dot || !line) return;
      var h = line.offsetHeight || 120, r = c.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (start - r.top) / (start - end)));
      dot.style.top = (p * h) + 'px';
    });
  }
  function updBars() {
    var bars = document.querySelectorAll('.sohei-v3 .pc-bar');
    if (!bars.length || reduce) return;
    var vh = window.innerHeight || 800, start = vh * 0.9, end = vh * 0.42;
    bars.forEach(function (bar) {
      var r = bar.parentElement.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (start - r.top) / (start - end)));
      bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
    });
  }
  function updWf() {
    document.querySelectorAll('.sohei-v3 .wf-grid').forEach(function (grid) {
      var nb = grid.querySelectorAll('.wf-nav button'), panels = grid.querySelectorAll('.wf-panel');
      if (!panels.length) return;
      var center = window.innerHeight / 2, best = 0, bd = Infinity;
      panels.forEach(function (p, i) {
        var r = p.getBoundingClientRect(), c = r.top + r.height / 2, d = Math.abs(c - center);
        if (d < bd) { bd = d; best = i; }
      });
      nb.forEach(function (b, k) { b.classList.toggle('on', k === best); });
    });
  }
  /* ── Objection stacking: pure CSS position:sticky (see .obj-card in sohei-v3.css).
       The earlier JS pin set a translate on every card from getBoundingClientRect on each
       scroll frame; on iOS Safari that runs a frame behind the compositor and every
       address-bar resize re-fired it, so the cards visibly jumped while scrolling. ── */

  /* ── Waterfall nav pin — measured from grid rect + nav's constant offsetTop ── */
  function updWfNav() {
    document.querySelectorAll('.sohei-v3 .wf-grid').forEach(function (grid) {
      var nav = grid.querySelector('.wf-nav');
      if (!nav) return;
      if (reduce || window.innerWidth <= 860) { nav.style.transform = ''; return; }
      var gridTop = grid.getBoundingClientRect().top;
      var gridH = grid.offsetHeight;
      var natTop = nav.offsetTop, navH = nav.offsetHeight;
      var pinLine = 100;
      var desired = pinLine - (gridTop + natTop);
      if (desired < 0) desired = 0;
      var maxT = gridH - natTop - navH;
      if (maxT < 0) maxT = 0;
      if (desired > maxT) desired = maxT;
      nav.style.transform = 'translate3d(0,' + desired.toFixed(2) + 'px,0)';
    });
  }

  function updAll() { updDots(); updBars(); updWf(); updWfNav(); }

  /* ── Hero YouTube background (muted autoplay + segment loop) ── */
  function ytReady(cb) {
    if (window.YT && window.YT.Player) { cb(); return; }
    (window.__sv3YtCbs = window.__sv3YtCbs || []).push(cb);
    if (window.__sv3YtLoading) return;
    window.__sv3YtLoading = true;
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') prev();
      (window.__sv3YtCbs || []).forEach(function (f) { f(); });
      window.__sv3YtCbs = [];
    };
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }
  function makeYt(mount) {
    var id = mount.getAttribute('data-yt'); if (!id) return;
    var start = parseFloat(mount.getAttribute('data-start')) || 0;
    var end = parseFloat(mount.getAttribute('data-end')) || 0;
    var holder = document.createElement('div'); mount.appendChild(holder);
    ytReady(function () {
      var player = new YT.Player(holder, {
        videoId: id,
        playerVars: { autoplay: 1, controls: 0, disablekb: 1, fs: 0, iv_load_policy: 3, modestbranding: 1, rel: 0, playsinline: 1, mute: 1, loop: 1, playlist: id, start: Math.floor(start) },
        events: {
          onReady: function (e) {
            try {
              e.target.mute(); e.target.playVideo();
              var f = e.target.getIframe();
              if (f) { f.setAttribute('tabindex', '-1'); f.setAttribute('aria-hidden', 'true'); f.style.pointerEvents = 'none'; }
            } catch (err) {}
          },
          onStateChange: function (e) {
            if (e.data === YT.PlayerState.PLAYING) {
              var pel = mount.parentNode && mount.parentNode.querySelector('.hero-poster');
              if (pel) pel.classList.add('sv3-hide');
              if (mount.__t) clearInterval(mount.__t);
              mount.__t = setInterval(function () {
                try { if (end > 0 && player.getCurrentTime() >= end) player.seekTo(start, true); } catch (err) {}
              }, 200);
            } else if (e.data === YT.PlayerState.ENDED) {
              try { player.seekTo(start, true); player.playVideo(); } catch (err) {}
            }
          }
        }
      });
    });
  }
  function initHeroYt() {
    if (reduce) return;
    document.querySelectorAll('.sohei-v3 .hero-yt[data-yt]:not([data-yt-init])').forEach(function (m) {
      m.setAttribute('data-yt-init', '1'); makeYt(m);
    });
  }

  /* ── Cursor dot-field ── The .sv3-dotfield element is rendered in HTML (hero) so the page
     keeps its background without JS. Here we move it to <body> (out of any section stacking
     context) and, for mouse users, reveal dots around the pointer. Bind once. */
  function initDotField() {
    var f = document.querySelector('.sv3-dotfield');
    if (!f) return;
    if (f.parentNode !== document.body && document.body) document.body.appendChild(f);
    if (window.__sv3dotsBound) return;
    window.__sv3dotsBound = true;
    if (reduce) return;
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return; /* mouse only */
    var tx = 0, ty = 0, queued = false;
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY;
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        f.style.setProperty('--mx', tx + 'px');
        f.style.setProperty('--my', ty + 'px');
        f.classList.add('on');
        queued = false;
      });
    }, { passive: true });
    document.addEventListener('mouseleave', function () { f.classList.remove('on'); });
  }

  /* ── Hero background video: start after the page has loaded ──
     The hero renders the <video> inert (no autoplay, preload="none") so the 5.8 MB file
     does not compete with the first paint. Kick it off once everything else is in. */
  function initHeroVideo() {
    document.querySelectorAll('.sohei-v3 .hero-bg video[data-sv3-autoplay]:not([data-sv3-video])').forEach(function (v) {
      v.setAttribute('data-sv3-video', '1');
      if (reduce) return;
      var start = function () {
        v.preload = 'auto'; v.muted = true; v.loop = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      };
      if (document.readyState === 'complete') setTimeout(start, 300);
      else window.addEventListener('load', function () { setTimeout(start, 300); });
    });
  }

  function initSV3() {
    initReveals(); initRot(); initMarquee(); initCount(); initWf(); initLightbox(); initHeroYt(); initHeroVideo(); initDotField(); updAll();
  }

  if (!window.__sv3bound) {
    window.__sv3bound = true;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { updAll(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', updAll);
    document.addEventListener('shopify:section:load', initSV3);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSV3);
  else initSV3();
})();
